import { c as _c } from "react/compiler-runtime";
import { Button } from "@website/ui/button";
import { useCounterButton } from "@website/ui/counter-button/counter-button.hook";
import styles from "@website/ui/counter-button/counter-button.module.scss";
import { CounterButtonPropertiesType } from "@website/ui/counter-button/counter-button.types";
import { FC } from "react";
export const CounterButton: FC<CounterButtonPropertiesType> = properties => {
  const $ = _c(24);
  const {
    className,
    variant,
    decreaseDisabled,
    increaseDisabled,
    helperText,
    error,
    size: t0
  } = properties;
  const size = t0 === undefined ? "medium" : t0;
  const {
    value,
    rootProps,
    decreaseButtonProps,
    increaseButtonProps,
    valueProps
  } = useCounterButton(properties);
  const t1 = `${styles["counter-button"]} ${styles[variant ?? "contained"]} ${className ?? ""}`;
  let t2;
  if ($[0] !== increaseButtonProps || $[1] !== size) {
    t2 = <Button {...increaseButtonProps} size={size} type="button" />;
    $[0] = increaseButtonProps;
    $[1] = size;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${styles.value} !text-body-1 ! !text-on-surface-medium-emphasis !size-9 ${variant === "outline" ? "!border-none" : ""}`;
  let t4;
  if ($[3] !== t3 || $[4] !== value || $[5] !== valueProps) {
    t4 = <div {...valueProps} className={t3}>{value}</div>;
    $[3] = t3;
    $[4] = value;
    $[5] = valueProps;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== decreaseButtonProps || $[8] !== size) {
    t5 = <Button {...decreaseButtonProps} size={size} type="button" />;
    $[7] = decreaseButtonProps;
    $[8] = size;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== rootProps || $[11] !== t1 || $[12] !== t2 || $[13] !== t4 || $[14] !== t5) {
    t6 = <div {...rootProps} className={t1}>{t2}{t4}{t5}</div>;
    $[10] = rootProps;
    $[11] = t1;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== decreaseDisabled || $[17] !== error || $[18] !== helperText || $[19] !== increaseDisabled) {
    t7 = helperText ? <div className={`${styles["helper-text"]} ${decreaseDisabled && increaseDisabled && styles.disabled} ${error && styles.error}`}>{helperText}</div> : null;
    $[16] = decreaseDisabled;
    $[17] = error;
    $[18] = helperText;
    $[19] = increaseDisabled;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t6 || $[22] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};